import { getBotGender, getBotGenderIndex } from "@mono/bot/data"
import avatar1 from "@/images/avatars/avatar1.webp"
import avatar2 from "@/images/avatars/avatar2.webp"
import avatar3 from "@/images/avatars/avatar3.webp"
import avatar4 from "@/images/avatars/avatar4.webp"
import avatar5 from "@/images/avatars/avatar5.webp"
import avatar6 from "@/images/avatars/avatar6.webp"
import avatar7 from "@/images/avatars/avatar7.webp"

// Which of the eight avatars read as which gender. Bots are named after people
// (botProfiles in bot/data.ts), so the face has to match the name.
const maleAvatars = [avatar2, avatar4]
const femaleAvatars = [avatar1, avatar3, avatar5, avatar6, avatar7]

// Humans have no gender on their account, so they keep the original
// seat-coloured assignment.
const avatarsByPlayerOrder = [avatar4, avatar1, avatar2, avatar3]

// The avatar to fall back to when a player has no uploaded profile image. Bots
// get one matching the gender of their name; everybody else gets the avatar for
// their seat.
export const getPlayerAvatar = (player: IPlayer, user?: IUser) => {
  const gender = player.bot ? getBotGender(user?.username) : undefined
  if (!gender) return avatarsByPlayerOrder[player.order]

  const avatars = gender === "male" ? maleAvatars : femaleAvatars
  return avatars[getBotGenderIndex(user?.username) % avatars.length]
}
